export default __webpack_public_path__ + "static/media/w_f_2026_h.a24de624.jpg";